var render, staticRenderFns
import script from "./HKLInputOperatorNumber.vue?vue&type=script&lang=js&"
export * from "./HKLInputOperatorNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac8487a')) {
      api.createRecord('0ac8487a', component.options)
    } else {
      api.reload('0ac8487a', component.options)
    }
    
  }
}
component.options.__file = "src/controls/Input/HKLInputOperatorNumber.vue"
export default component.exports